import { useState, useEffect, useRef } from 'react'
import Header from './components/Header'
import Hero from './components/Hero'
import About from './components/About'
import Services from './components/Services'
import Contact from './components/Contact'
import Footer from './components/Footer'

function App() {
  const [activeSection, setActiveSection] = useState('hero')
  const sectionRefs = useRef<Record<string, HTMLDivElement | null>>({
    hero: null,
    about: null,
    services: null,
    contact: null,
  })

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id)
          }
        })
      },
      {
        rootMargin: '-20% 0px -60% 0px',
        threshold: 0.1,
      }
    )

    Object.values(sectionRefs.current).forEach((ref) => {
      if (ref) observer.observe(ref)
    })

    return () => observer.disconnect()
  }, [])

  const scrollToSection = (sectionId: string) => {
    const element = sectionRefs.current[sectionId]
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <div className="app">
      <Header
        activeSection={activeSection}
        onNavigate={scrollToSection}
      />
      <main id="main-content">
        <Hero ref={el => sectionRefs.current.hero = el} id="hero" />
        <About ref={el => sectionRefs.current.about = el} id="about" />
        <Services ref={el => sectionRefs.current.services = el} id="services" />
        <Contact ref={el => sectionRefs.current.contact = el} id="contact" />
      </main>
      <Footer />
    </div>
  )
}

export default App